import { Card, Space, Typography } from "antd";
import type { IntakeAnswer } from "./types";
import InlineEditable from "./InlineEditable";

interface Props {
  answers: IntakeAnswer[];
  /** Called with the full new answers list whenever a single answer is edited. */
  onAnswerEdit?: (next: IntakeAnswer[]) => Promise<void>;
  canEdit?: boolean;
}

export default function AnswersTab({ answers, onAnswerEdit, canEdit = false }: Props) {
  if (!answers.length) {
    return (
      <Card size="small">
        <Typography.Text type="secondary">No intake questions available.</Typography.Text>
      </Card>
    );
  }
  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      {answers.map((answer, idx) => (
        <Card
          key={answer.questionId || answer.question || idx}
          type="inner"
          title={answer.question || "Question"}
        >
          <InlineEditable
            value={answer.answer || ""}
            canEdit={Boolean(canEdit && onAnswerEdit && answer.questionId)}
            multiline
            ariaLabel={answer.question || answer.questionId || "answer"}
            onSave={async (next) => {
              if (!onAnswerEdit) return;
              const nextList = answers.map((a, i) =>
                i === idx ? { ...a, answer: next } : a,
              );
              await onAnswerEdit(nextList);
            }}
          />
        </Card>
      ))}
    </Space>
  );
}
